import React, { PureComponent } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

// import './App.css';

class CropImage extends PureComponent {
  state = {
    src: null,
    crop: {
      unit: '%',
      width: 50,
      height: 50,
      aspect: 1 / 1,
    },
  };

  atual = {};

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () =>
        this.setState({ src: reader.result })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    //  this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        'newFile.jpeg'
      );
      this.setState({ croppedImageUrl });
      // this.props.atualizaBotFab(croppedImageUrl);
    }
  }

  selectCut = () => {
    this.props.atualizaBotFab(this.atual);
  };

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error('Canvas is empty');
          return;
        }
        blob.name = fileName;
        // this.props.atualizaBotFab(blob);
        // this.setState({atualCut: blob})
        this.atual = blob;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
      }, 'image/jpeg');
    });
  }

  render() {
    const { crop, croppedImageUrl, src } = this.state;

    return (
      <div className="modal-content modal-content-img">
        <div className="modal-header modal-header-img">
          <div className="App linha" style={{ textAlign: 'center' }}>
            <div style={{ display: 'flex' }}>
              <div className="form-group-serch-picture">
                <label htmlFor="fupload">Buscar Foto</label>
                <input
                  id="fupload"
                  className="file-path validate"
                  type="file"
                  placeholder="Buscar Foto"
                  accept="image/*"
                  onChange={this.onSelectFile}
                />
              </div>
              <div style={{ marginLeft: '20px' }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
              <div style={{ marginLeft: '20px' }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.selectCut}
                  data-dismiss="modal"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="coluna">
          {src && (
            <ReactCrop
              src={src}
              crop={crop}
              ruleOfThirds
              onImageLoaded={this.onImageLoaded}
              onComplete={this.onCropComplete}
              onChange={this.onCropChange}
            />
          )}
          {croppedImageUrl && (
            <img alt="Crop" className="cropped" src={croppedImageUrl} />
          )}
        </div>
      </div>
    );
  }
}

// ReactDOM.render(<CropImage />, document.getElementById('root'));

export default CropImage;
